//     This code was generated by a Reinforced.Typings tool.
//     Changes to this file may cause incorrect behavior and will be lost if
//     the code is regenerated.

export enum GeograficType {
	Nation = 0,
	Region = 1,
	Province = 2
}
